import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';
import { useSiteImage } from '@/hooks/useSiteImage';
import ThreeStepBuyBox from './ThreeStepBuyBox';

export default function StepCTA() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const logoUrl = useSiteImage('footer.logo', '/brand/rxk-logo-footer.png');
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';

  return (
    <section className="w-full bg-[#1A1A1A] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Same admin-editable logo image the footer uses, instead of a typed wordmark */}
          <img src={logoUrl} alt="Rx.K Seoul" className="h-9 md:h-11 w-auto" />

          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-[1.15]">
            {t('threeStep.cta.heading')}
          </h2>

          <p className="text-sm text-white/40 font-light leading-[1.8] max-w-lg">
            {t('threeStep.cta.desc')}
          </p>

          <ThreeStepBuyBox align="center" />

          <Link
            to={prefix + '/stores'}
            className="text-xs tracking-[0.15em] uppercase text-white/50 hover:text-white transition-colors"
          >
            {t('common.whereToBuy')} →
          </Link>
        </div>
      </div>
    </section>
  );
}